export enum MapMode {
  Default,
  Widget,
}
